const EN = {
  INPUTTYPE: {
    input: {
      default: "Text box (Standard)",
      email: "Email",
      scala: "Scala",
      barcode: "Barcode",
      phone: "Phone",
      textarea: "Textarea",
      password: "Password",
      flex: "Flex",
      number: "Number",
      currency: "Currency",
      slider: "Slider",
      ranking: "Ranking",
      ipv4: "IPV4",
      ipv6: "IPV6",
      domain: "Domain",
      multiInput: "MultiInput",
      checktext: "Checktext",
      QRReader: "Read QR",
      QRGen: "Generator QR"
    },
    file: {
      default: "File upload"
    },
    boolean: {
      standar: "True or False",
      switch: "Switch true or false"
    },
    signature: {
      sign: "Signature",
      photo: "sign's image",
      dialog: "Option dialog for signature"
    },
    choice: {
      multi: "Multiple option",
      multiOther: "Multiple choice (other, which one?)",
      radio: "Unique selection",
      radioOther: "Unique selection (other, which one?)"
    },
    date: {
      datetime: "Datetime",
      calendar: "Date",
      time: "Time",
      unixtime: "Duration of activities or events"
    },
    label: {
      label: "Etiqueta",
      link: "Link",
      paragraph: "Paragraph",
      section: "Section",
      info: "Informative list",
      action: "Actions"
    },
    photo: {
      camera: "Camera",
      gallery: "Photo gallery",
      "gallery/camera": "Photo gallery or camera",
      url: "Imagen por url"
    },
    viewer: {
      web: "Web",
      document: "Document"
    },
    geo: {
      google: "Google",
      servi: "Servinformación",
      location: "Location (Coordinates)"
    },
    map: {
      google: "Google",
      servi: "Servinformación"
    },
    video: {
      url: "Video by url"
    },
    subform: {
      standar: "Standard Subform"
    },
    datasource: {
      standar: "Standard data source",
      database: "Data Base",
      select: "Selection"
    }
  },
  FORMS: {
    input: "Input",
    file: "File",
    date: "Date",
    signature: "Signature",
    geo: "Geo",
    choice: "Choice",
    boolean: "Boolean",
    label: "Label",
    link: "Link",
    paragraph: "Paragraph",
    video: "Video",
    photo: "Photo",
    map: "Map",
    number: "Numbers",
    network: "Network",
    list: "List",
    qr: "QR",
    informative: "Informative",
    viewer: "Information window",
    subform: "Subformulario",
    datasource: "Data Source",
    save: "Save",
    exit: "Back",
    imagen_url: "Image per url",
    ranges: "Input range"
  },
  MODULE: {
    nameForm: "Form name",
    group: "Group",
    version: "Version",
    isForm: "Is it a subform?",
    addPage: "Add page",
    pagination: "Pagination",
    totalQuestions: "questions total",
    page: "Page",
    btnAddQuestion: "Add question",
    btnAddQuestionOteher: "add another question",
    btnAddComponent: "Add component",
    btnAddComponentOther: "Add another component",
    downloadJson: "Download json",
    saveForm: "Save form",
    cleanForm: "Clean form",
    listForms: "New Form",
    openForm: "Open Form",

    //TRANSLATE CARD QUESTION
    label: "Label",
    placeHolderLabel: "Question name",
    component: "Component",
    class: "Class",
    description: "Help description",
    subtitleDescription: "Short description to guide the user on the question.",
    required: "Required",
    btnAddDependency: "Add Dependency",
    setting: "Set up",
    Pregunta: "Question",
    Componente: "Component",

    //MESSAGES ALERTS
    emptyLabel: "The label must not be empty and its character string must be greater than 2.",
    emptyOption: "The component must have at least one option.",
    requiredUrl: "This component requires a content or a url",
    requiredSubform: "This component requires adding a subform.",
    requiredFql: "Add the sql or fql query.",
    requiredType: "Select the type of action.",
    requiredOriginData: "There is no data source for this component.",
    RequiredMainField: "Select the main search field.",
    requiredListData: "This component requires adding a data list, enter when configuring.",
    requiredQuestionsToActions: "Select the questions to take action.",
    maxQuestionsToActions: "You must select at least two questions to perform the action",
    maxQuestionMode: "The mode must contain a minimum of 3 questions.",
    requiredSelectMutipleToFlex: "The flex is not related to any multiple-choice questions.",
    smgModeSchema: "The 'questions' property of actions Must contain at least 3 elements for the mode",
    smgTwoElements: "The 'questions' property of actions must contain at least 2 elements",
    msgContainerElements: "It is not within the available operations.",
    "msgErrorInheritedSubform": "There are missing fields to complete. review the form",


    //SETTING QUESTIONS
    inputText: "Enter your text",
    hexaColor: "Hexadecimal color",
    minValue: "Minimum value",
    maxValue: "Maximum value",
    addOtherOption: "Add another option",
    getDateYear: "Take data from the year:",
    toYear: "Until the year:",
    selectFormatDate: "Select time format:",
    settingDomains: "Configure domains?",
    acceptAllDomains: "Accept all domains",
    settingDomains: "Configure accepted domains",
    subtitleDomain: "Accepted domains (@ gmail.com, @ hotmail.com, etc) (Defines the valid domain (s) accepted.)",
    matchList: "List of matches. (Validate that the domain meets the matches.)",
    typeFile: "Type of file.",
    lengthFile: "Maximum file size:",
    extensionsFiles: "What extensions do you want to accept:",
    valueMaxRanking: "Maximum value of the grade (Integer value).",
    titleScala: "Add options",
    typePassword: "Password type",
    sliderOrientation: "Slider orientation.",
    sliderValueInitial: "Initial value:",
    optionMinimas: "Minimum options:",
    optionMaximas: "Maximum options:",
    addOptionsTolist: "Add options to the list. (Selectable options.)",
    MultiDescription: "Label description",
    otherWitch: "Other, which one?",
    typeSelector: "Selector type",
    valueDefaultSwitch: "Switch default value",
    SwitchDescription: "Description",
    selectTypePhone: "Select the type of phone.",
    inputKey: "Enter the map key:",
    typeGeo: "Georeferencing type",
    typeFont: "Font type:",
    lengthFont: "Font size",
    textiewLabel: "Text:",
    inputLink: "Enter the link",
    selectModeView: "Select display mode.",
    inputParagraph: "Enter the paragraph:",

    containe: "Contains",
    dependencies: "Dependencies",

    listInfo: {
      whereisData: "Where do you want to extract the data from:",
      locale: "Local",
      fromDataOrigin: "From a data source",
      title: "Add the options manually or from a data source with the button located at the bottom.",
      nameLabel: "Name for informational label",
      keyCode: "Search key",
      add: "Add"
    },
    video: {
      label: "Enter video url:",
      subtitle: "Verify that the video is public on the web and that it contains the https protocol."
    },
    image: {
      label: "Image url:",
      subtitle: "The url must be HTTPS"
    },
    map: {
      labelView: "Enter url of the map to display:",
      subtitleView: "Enter url of the map to display",
      subtitleKey: "Necessary to consume georeferencing services."
    },
    subforms: {
      labelSubform: "Select the subform",
      maxAnswer: "Maximum number of responses:",
      minAnswer: "Minimum number of responses:"
    },

    originDabataseStandar: {
      typeMethod: "Select method:",
      // limit: "Search limit",
      limit: "Total records",
      btnOrigin: "Data origin",
      keyCode: "Data source key",
      fieldMainSearch: "Main search field:"
    },

    originDataBase: {
      typeQuery: "Query type:",
      typeAction: "Type of action:",
      query: "Query",
      messagge: "Message"
    },

    originSelect: {
      limit: "Search limit",
      btnOrigin: "Data origin",
      typeQuery: "Query type:",
      typeAction: "Type of action:",
      query: "Query",
      messagge: "Message"
    },

    File: {
      allExtensions: "All extensions",
      images: "Images",
      documents: "Documentos",
      Compressed: "Compressed files"
    },
    geo: {
      geo: "Geocoder",
      assisted: "Assisted",
      reverse: "Reverse"
    },
    phone: {
      movil: "Mobile phones",
      fixed: "Fixed telephones",
      movilFixed: "Fixed and mobile"
    },
    radio: {
      radio: "Radio",
      comoboBox: "Combo Box",
      unique: "Unique for multiple answers"
    },
    password: {
      alphanumerico: "Alphanumeric",
      string: "Character string",
      number: "Numeric"
    },
    time: {
      standar: "AM/PM",
      militar: "MILITARY"
    },
    fuentes: {
      bold: "Bold font",
      normal: "Normal",
      italic: "Italic"
    },
    viewer: {
      embebido: "Embedded",
      popup: "Popup",
      labelInputWeb: "Enter url of a web:",
      labelInputDocument: "Enter url of a public pdf document:",
      labelViewInformation: "Way of displaying external information.",
      labelOrientation: "Component orientation."
    },
    paragraph: {
      onlyParagraph: "Paragraph only",
      titleParagraph: "Title and Paragraph"
    },
    orientation: {
      default: "Default",
      landscape: "Landscape",
      portrait: "Portrait"
    },
    View: {
      external: "External",
      popup: "Popup"
    },
    methodOrigin: {
      readWrite: "Reading and editing",
      onlyRead: "Read only"
    },
    actions: {
      on_trigger: "Button action",
      on_event: "Action by event",
      on_depend: "Dependency action",
      add: "Summation",
      sub: "Successive subtractions",
      multiply: 'Multiply',
      divider: 'Division',
      concat: "Contatenar",
      avg: "Average",
      mode: "Mode",
      median: "Median",
      min: "Minimum",
      max: "Maximum",
      default: "Without format",
      number: "Numeric format",
      currency: "Currency format",
      percent: "Percentage format",
      selectQuestions: "Select questions",
      actionMode: "Run mode",
      typeAction: "Type of action",
      formatDisplay: "Format to be displayed",
      semicolon: 'Semicolon',
      underscore: 'Underscore',
      pipe: 'Pipe',
      comma: 'Comma',
      dash: 'Dash',
      space: 'Space'
    }
  },
  MODALS: {
    actions: {
      listQuestions: "List of questions",
      search: "Search...",
      ToAccept: "Accept",
      cancel: "Cancel"
    },
    originSelect: {
      title: "Select the question for the condition",
      searchPlaceHolder: "Search by id or description ..."
    },
    originSelectTrigger: {
      title: "Data origin",
      total: "Total records:",
      Preview: "Preview",
      all: "All"
    },
    originChoice: {
      messagge: "How many records do you want to see in the options?",
      messagge2: "You already have data in manual Origin. What do you want to do with the new information?",
      add: "Add",
      Replace: "Replace",
      accept: "Accept"
    },
    movePage: {
      title: "Move question",
      pages: "Pages",
      page: "Page",
      positionQuestion: "Question position:",
      move: "Move",
      toInit: "At the beginning",
      after: "After",
      before: "Before",
      toFinal: "In the end"
    },
    listForms: {
      titleSelect: "Select the form",
      titleClean: "Delete form from list.",
      name: "Name",
      state: "State",
      date: "Date",
      create: "New",
      update: "To Update",
      messaggeAlert: "You may have unsaved changes.",
      confirmMessage: "Do you want to delete the form from the list?",
      btnAccept: "Accept",
      btnCancel: "Cancel"
    },
    listInformative: {
      title: "Data origin",
      selectOriginData: "Select a data source",
      totalRecords: "Total records",
      selectField: "Select two fields:",
      btnPreview: "Preview",
      limitData: "Data limit",
      messagges1: "Select the field to be displayed as the informational label.",
      messagges2: "You already have data in the informative list. What do you want to do with the new information?",
      btnAdd: "Add",
      btnReplace: "Replace"
    },
    flex: {
      title: "Flex configuration",
      selectQuestion: "Select question",
      selectOptions: "Select option",
      component: "Component",
      btnAddQuestion: "Add question",
      Id: "Id",
      description: "Description",
      typeComponent: "Type",
      delete: "Delete",
      maximumSize: "Maximum length:",
      minimumSize: "Minimum length:"
    },
    dependencias: {
      title: "Create dependencies",
      searchPlaceHolder: "Search question ...",
      tabQuestion: "Questions",
      tabDependencies: "Dependents",
      standar: "Standard",
      compuesta: "Compound",
      typeRelated: "Type of relationship?",
      message: "The character string entered will be the condition for the child questions to be displayed.",
      btnCreateDependency: "Create dependency",
      all: "All"
    },
    modalDependencias: {
      dependence: "Dependence",
      dependencyBuilder: "Dependency Builder",
      standard: "Standard",
      composite: "Composite",
      textEquals: "(Text) Equal to",
      passEquals: "(Password) Equal to",
      emailEquals: "(Email) Equal to",
      sliderEquals: "(Slider) Equal to",
      rankingEquals: "(Rank) Equal to",
      numberEquals: "(Number) Equal to",
      valueEquals: "(Value) Equal to",
      uniqueValue: "(Single value) Equal to",
      multiValues: "Value(s) Equal To",
      codebarEquals: "(Bar Code) Equal to",
      emptyFull: "Empty full",
      remove: "Remove",
      add: "Add",
      show: "Show",
      delete: "Delete",
      search: "Search..."
    }
  }
};

export default EN;
